import api from "./api";

export const companyService = {
    async get() {
        const { data } = await api.get("/company");
        return data;
    },
    async update(payload) {
        const { data } = await api.patch("/company", payload);
        return data;
    },
};
